/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events,@typescript-eslint/ban-ts-comment */
import React, { useRef, useState } from "react";
import { uploadImage } from "./image-utils";
import useCustomizableContext from "~/CustomizableToolPage/useCustomizableContext";
import { addImage } from "~/CustomizableToolPage/fabric/utils";
import { UserAsset } from "~/CustomizableToolPage/types";
import { User } from "~/common/Store/models/User";

const UploadDropzone = ({ user }: { user: User }) => {
  const [dragoverPresent, setDragoverPresent] = useState(false);
  const [uploadError, setUploadError] = useState<string>();
  const fileInputRef = useRef<HTMLInputElement>();

  const {
    userAssets,
    fabric: { canvas },
    // @ts-ignore
    addUserAssets,
  } = useCustomizableContext();

  const handleFileUploading = async (files: FileList) => {
    let response;
    try {
      const result = await uploadImage({
        userId: user.index || "",
        sessionId: user?.sessionId || "",
        files,
      });

      if (!result?.ok) {
        setUploadError("There was an error when uploading. Please try again.");
        return;
      }

      response = await result.json<UserAsset>();
      addUserAssets([response]);

      addImage(canvas, response.path, response.id);
      // @ts-ignore
    } catch (e: Error) {
      setUploadError(e.message);
    }
  };

  const handleFileDropped = (e: React.DragEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();

    setDragoverPresent(false);

    if (e.dataTransfer.files.length) {
      handleFileUploading(e.dataTransfer.files);
    } else {
      const path = e.dataTransfer.getData("text");
      const imageData = userAssets[path];

      if (!imageData) return;
      addImage(canvas, imageData.path, imageData.id);
    }
  };

  const handleFileUpload = async ({
    target: { files },
  }: React.ChangeEvent<HTMLInputElement>) => {
    if (!files || !files.length) {
      return;
    }

    handleFileUploading(files);
  };

  return (
    <div
      id="upload-dropzone"
      className={`customize__upload flex ${dragoverPresent ? "dragover" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        setDragoverPresent(true);
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        setDragoverPresent(false);
      }}
      onDrop={handleFileDropped}
      onClick={() => fileInputRef?.current?.click()}
    >
      <input
        // @ts-ignore
        ref={fileInputRef}
        type="file"
        hidden
        onChange={handleFileUpload}
      />
      {uploadError && <div className="w-full text-error">{uploadError}</div>}
      Upload Image or drag and drop
    </div>
  );
};

export default UploadDropzone;
